module.exports = __webpack_public_path__ + "img/linkedin.97982080.svg";